import { useLanguageContext } from '../../contexts/language-context';
import { useContentContext } from '../../contexts/content_context';
import './home.css';

const Home = () => {
  const { language } = useLanguageContext();
  const { setContent } = useContentContext();

  const isEn = language === 'en';

  return (
    <main className="hero">
      <div className="kb-container hero__container">

        {/* Eyebrow */}
        <p className="hero__eyebrow">
          <span className="hero__eyebrow-dot" />
          {isEn ? 'Available for new opportunities' : 'Disponible pour de nouvelles opportunités'}
        </p>

        {/* Name */}
        <h1 className="hero__name">Karim Benhallam</h1>

        {/* Role */}
        <p className="hero__role">
          {isEn ? 'Full Stack Developer' : 'Développeur Full Stack'}
        </p>

        {/* One-liner */}
        <p className="hero__tagline">
          {isEn
            ? 'I build products end-to-end — from architecture decisions to shipped features. Currently at Ubee, helping scale a platform now used across Québec.'
            : "Je construis des produits de bout en bout — des décisions d'architecture aux fonctionnalités livrées. Actuellement chez Ubee, contribuant à faire évoluer une plateforme utilisée dans tout le Québec."}
        </p>

        {/* CTAs */}
        <div className="hero__ctas">
          <button
            className="hero__cta hero__cta--primary"
            onClick={() => setContent('work')}
          >
            {isEn ? 'View my work' : 'Voir mes projets'}
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
              <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
          <a
            href="mailto:karimbenhallam21@gmail.com"
            className="hero__cta hero__cta--secondary"
          >
            {isEn ? 'Get in touch' : 'Me contacter'}
          </a>
        </div>

        {/* Social links */}
        <div className="hero__links">
          <a
            href="https://github.com/KarimBenhallam/KarimBenhallam.github.io"
            target="_blank"
            rel="noopener noreferrer"
            className="hero__link"
            aria-label="GitHub"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <path d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" />
            </svg>
            GitHub
          </a>
          <a
            href="https://www.linkedin.com/in/karim-benhallam-192a84196/"
            target="_blank"
            rel="noopener noreferrer"
            className="hero__link"
            aria-label="LinkedIn"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
              <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
            </svg>
            LinkedIn
          </a>
        </div>

        {/* Scroll hint */}
        <button
          className="hero__scroll-hint"
          onClick={() => document.getElementById('skills')?.scrollIntoView({ behavior: 'smooth' })}
          aria-label={isEn ? 'Scroll to skills section' : 'Défiler vers les compétences'}
        >
          <span>{isEn ? 'Scroll to explore' : 'Défiler pour explorer'}</span>
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
            <path d="M7 2v10M3 8l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>

      </div>
    </main>
  );
};

export default Home;
